//# sourceMappingURL=calendarDateFormatter.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-calendar/dist/esm/src/interfaces/calendarDateFormatter.interface.js
// module id = 1255
// module chunks = 4